var $7d885e2935e9ed01$exports = {};
$7d885e2935e9ed01$exports = {
    "pending": `oczekuj\u{105}ce`
};


export {$7d885e2935e9ed01$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
